export default __webpack_public_path__ + "static/media/avatar.1c4b90a6.svg";